module.exports = __webpack_public_path__ + "img/tz6.b6b8fb7b.png";